/**
 * @deprecated This file is deprecated and will be removed.
 * Avatar functionality has been moved to src/components/common/Avatar.tsx
 * Please use the new Avatar component instead:
 *
 * import { Avatar } from '../components/common/Avatar';
 *
 * Example usage:
 * ```tsx
 * <Avatar
 *   size={32}
 *   type="Contact"
 *   teamId={contact.teamId?.toString()}
 *   rlpPersonId={contact.rlpPersonId}
 *   avatarUrl={contact.rlpPersonId ? `//admin.rlpnetwork.com/api/users/photo/${contact.rlpPersonId}` : undefined}
 *   className="rounded-full"
 * />
 * ```
 *
 * The Avatar component provides:
 * - Consistent avatar styling across the application
 * - Team-based coloring
 * - Support for both image URLs and initials
 * - Proper cleanup of DOM elements
 *
 * @see src/components/common/Avatar.tsx for implementation details
 */

// Keeping empty exports to prevent import errors during migration
import { Contact } from '../models/Contact';
export const getContactPhotoUrl = (contact: Contact): string => {
  return contact.rlpPersonId
    ? `//admin.rlpnetwork.com/api/users/photo/${contact.rlpPersonId}`
    : '//rlpnetwork.com/wp-content/themes/rlp/img/person.png';
};
export const getAvatarConfig = () => ({ initials: '', bgColor: '', textColor: '' });
